import { CopyBooking } from "~/components/admin/bookings";
import PageMeta from "~/components/common/meta";

export const ScreenCopyBooking = () => {
  return (
    <>
      <PageMeta title="Copy Booking | Art Handler" />
      <CopyBooking />
    </>
  );
};
